export const RESULT_BADGE_ICON_SIZE = 12;
